import React from 'react';
import classNames from 'classnames';
import styled from '@emotion/styled';
import { FormattedMessage, useIntl } from 'react-intl';

import Required from 'common/Required';

const Wrapper = styled.div`
  margin-bottom: 18px;
`;

const Label = styled.label`
  margin-bottom: 8px;
`;

const Error = styled.span`
  font-size: 12px;
  font-weight: 700;
`;

/**
 * @typedef {{
 *  id: string,
 *  error?: string,
 *  touched?: string,
 *  title?: React.ReactNode,
 *  required?: boolean,
 * } & HTMLDivElement} FormItemProps
 */

/** @type {React.FC<FormItemProps>} */
const FormItem = ({ id, error, touched, title, required, children, ...rest }) => {
  const intl = useIntl();
  const canDisplayError = Boolean(error) && touched;

  return (
    <Wrapper className={classNames('flex-fill', { 'item-input-error': canDisplayError })} {...rest}>
      {title && (
        <Label htmlFor={id} data-cy="input-label" aria-label={required && intl.formatMessage({ id: 'web.validation.required', defaultMessage: 'This field is mandatory' })}>
          {required && <Required />}
          <span>{title}</span>
        </Label>
      )}
      {children}
      {canDisplayError && (
        <Error className="text-danger" data-cy="error">
          <FormattedMessage id={error} defaultMessage={error} />
        </Error>
      )}
    </Wrapper>
  );
};

export default FormItem;
